import { initDialog, openDialog } from '../common/dialog';

document.addEventListener('DOMContentLoaded', function () {
  const productPopupElement = $('#product-popup');
  if (productPopupElement.length === 0) return;

  const dialogElement = document.querySelector('.product-popup');
  const dialogCloseElement = dialogElement?.querySelector('.close-dialog-icon');
  window.dataLayer = window.dataLayer || [];

  let mouseleaveTriggered = false;
  setTimeout(() => {
    document.addEventListener('mouseleave', function onMouseLeave(e) {
      if (!mouseleaveTriggered && (e.clientY < 0 || e.clientX <= 0 || e.clientX >= window.innerWidth)) {
        const productPopup = initDialog('product-popup');
        openDialog(productPopup);
        mouseleaveTriggered = true;
        window.dataLayer.push({
          event: 'popup_product_show',
        });
        document.removeEventListener('mouseleave', onMouseLeave);
      }
    });
  }, 5000);

  dialogElement?.addEventListener('click', event => {
    if (event.target === dialogElement) {
      window.dataLayer.push({
        event: 'popup_product_stay_outside_click',
      });
    }
  });

  dialogCloseElement?.addEventListener('click', () => {
    window.dataLayer.push({
      event: 'popup_product_close_click',
    });
  });
});
